import { createAction } from "@reduxjs/toolkit";

// PlotCSCQ Actions
export const initPlotQuestion = createAction("INIT_PLOT_QUESTION");
export const selectOption = createAction("SELECT_OPTION");
export const validateSubmission = createAction("VALIDATE_SUBMISSION");
export const updateTextAnswer = createAction("UPDATE_TEXT_ANSWER");
